export default function WhyChooseStrip() {
  const highlights = [
    {
      icon: 'ri-shield-check-line',
      title: 'Licensed & Insured',
      description: 'Fully certified caregivers'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Compassionate Care',
      description: 'Treating clients like family'
    },
    {
      icon: 'ri-time-line',
      title: 'Flexible Scheduling',
      description: 'Care when you need it'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Experienced Team',
      description: 'Trained professionals'
    }
  ];

  return (
    <section className="py-16 bg-[#5C4F8A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-white text-center mb-12">
          Why Choose KaliKare?
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {highlights.map((item, index) => (
            <div
              key={index}
              className="text-center space-y-4 group cursor-pointer"
            >
              <div className="w-20 h-20 flex items-center justify-center mx-auto bg-white/10 rounded-full group-hover:bg-white/20 transition-all duration-300">
                <i className={`${item.icon} text-5xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-white">{item.title}</h3>
              <p className="text-sm text-white/90">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}